module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "textarea"
  }, [_c('Label', {
    style: (_vm.getStyle),
    attrs: {
      "label": _vm.label,
      "required": _vm.required,
      "bigLabel": _vm.bigLabel
    }
  }, [_c('textarea', {
    staticClass: "textarea__textarea",
    class: {
      textarea__textarea_long: _vm.bigLabel, textarea__textarea_red: _vm.vError
    },
    style: ({
      "min-height": _vm.minHeight ? _vm.minHeight : ""
    }),
    attrs: {
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.text($event)
      },
      "blur": function($event) {
        return _vm.blur($event)
      }
    }
  })]), (_vm.vError) ? _c('p', {
    staticClass: "textarea__error"
  }, [_vm._v(_vm._s(_vm.errorText))]) : _vm._e(), (_vm.description.length) ? _c('p', {
    staticClass: "textarea__description"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29d608d0","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/form/components/textarea/Textarea.vue
// module id = ba8b7c692c1980ffb7fd
// module chunks = 89